
<div class="container" [hidden]="workflowTargetInfo.correctRole">
  <div class="row">
    <div class="col">
      <div class="alert alert-info" [hidden]="!completelyHidden"><span>You do not have access to this step.  It will be completed by someone else.</span></div>
      <div class="alert alert-info" [hidden]="completelyHidden"><span>You cannot make changes to this step.  It will be completed by someone else.</span></div>
    </div>
  </div>
</div>